import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/search-blue.png'
import _imports_1 from '@/assets/img/upload-blue.png'


const _withScopeId = n => (_pushScopeId("data-v-05de5a81"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "header-top"
}
const _hoisted_2 = { class: "common-wrap header-top-wrap" }
const _hoisted_3 = { class: "header-top-left" }
const _hoisted_4 = { class: "header-top-right" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "搜索", -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "上传", -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]

import { onMounted, onUnmounted, ref } from 'vue'
import throttle from 'lodash/throttle'
import SubjectStage from './subject-stage.vue'
import LoginRegister from './login-register.vue'
import useHomeStore from '@/store/modules/home'
import { storeToRefs } from 'pinia'
import { useRouter, useRoute } from 'vue-router'
import useSearchStore from '@/store/modules/search'


export default {
  __name: 'header-scroll',
  setup(__props) {

const route = useRoute()


const homeStore = useHomeStore()
const { showScrollHeader, defaultTab, showUpload, isLogin, showLogin, } = storeToRefs(homeStore)
const searchStore = useSearchStore()
const { searchKeyWord } = storeToRefs(searchStore)
const router = useRouter()

//监听window滚动
const scrollListener = throttle(() => {
  const scrollTop = document.documentElement.scrollTop
  if (scrollTop > 176) {
    showScrollHeader.value = true
  } else {
    showScrollHeader.value = false
  }

}, 100)

onMounted(() => {
  window.addEventListener('scroll', scrollListener)
})

onUnmounted(() => {
  window.removeEventListener('scroll', scrollListener)
})



const goHome = () => {
  defaultTab.value = 0
  router.push('/home')
}

//点击上传资源
const clickUpload = () => {
  if (!isLogin.value) {
    showLogin.value = true
    return
  }
  showUpload.value = true
}

//点击搜索
const clickSearch = () => {
  if (searchKeyWord.value) {
    searchStore.getSeach()
  }
  defaultTab.value = null
  router.push({
    path: '/home/search'
  })
}

return (_ctx, _cache) => {
  return (_unref(showScrollHeader))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h1", { onClick: goHome }, "教师资源库"),
            _createVNode(SubjectStage)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: "search mr16",
              onClick: clickSearch
            }, _hoisted_7),
            (!_unref(route).path.includes('upload'))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "search mr16",
                  onClick: clickUpload
                }, _hoisted_10))
              : _createCommentVNode("", true),
            _createVNode(LoginRegister)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

}